import {ControlModel} from 'src/app/core/models/control.model';
import {ListItemVO} from 'src/app/core/vo/list-item.vo';

export class ConfigurationModel {
  selectedLanguage: any;
  controlModel: ControlModel = new ControlModel();
  languageInfo: any = [{languageId: 2, value: '', label: 'English'}, {languageId: 1, value: '', label: 'German'}];
  activeListItem: ListItemVO;
}
